window.oxgClickFFStartOverButton = ()=> {
  let form = document.querySelector('.frm_pro_form');
  if (!form) return
  let startOverBtn = form.querySelector('.frm_start_over')
  console.log(startOverBtn)
  let theForm = jQuery('#form_1-wella-new-briefing');
  console.log(theForm)
  startOverBtn.click()
}